import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { v4 as uuid } from "uuid"
import { AppDispatch, RootState } from "./store/store"
import wait from "../util/wait"

type Notification = {
    id: string
    title: string
    message: string
    persistent?: boolean
}
export function createNotification(
    title: string,
    message: string,
    persistent: boolean = false
): Notification {
    return {
        id: uuid().toString(),
        title,
        message,
        persistent
    }
}

interface NotificationState {
    notifications: Notification[]
}

const name = "notificationSlice"
const initialState: NotificationState = {
    notifications: []
}
export const notificationSlice = createSlice({
    name,
    initialState,
    reducers: {
        addNotification: (state, action: PayloadAction<Notification>) => {
            state.notifications = [...state.notifications, action.payload]
        },
        removeNotification: (state, action: PayloadAction<string>) => {
            state.notifications = [
                ...state.notifications.filter((n) => n.id !== action.payload)
            ]
        }
    }
})

export function showNotification(
    dispatch: AppDispatch,
    title: string,
    message: string
) {
    const notification = createNotification(title, message)
    dispatch(notificationSlice.actions.addNotification(notification))
    wait(5000).then(() =>
        dispatch(notificationSlice.actions.removeNotification(notification.id))
    )
}

export function showPersistentNotification(
    dispatch: AppDispatch,
    title: string,
    message: string
) {
    const notification = createNotification(title, message, true)
    dispatch(notificationSlice.actions.addNotification(notification))
}

export const selectNotification = (state: RootState) =>
    state.notification.notifications

export default notificationSlice.reducer
